import { isEmailValid } from '@spike/validations';
import Button from 'components/UI/V3/Button/Button';
import { Input } from 'components/UI/V3/Forms/Input/Input';
import GenericModal from 'components/UI/V3/Modals/GenericModal';
import { ChangeEvent, FunctionComponent, useMemo, useState } from 'react';
import { isTemporalEmail } from 'utils/ValidationUtils';
import styles from './SendInvoiceModal.module.scss';

interface SendInvoiceModalProps {
    email?: string | null;
    sending: boolean;
    onCancel: () => void;
    onSend: (_email: string) => void;
}

export const SendInvoiceModal: FunctionComponent<SendInvoiceModalProps> = ({ email, sending, onCancel, onSend }) => {
    const initialEmail = email && !isTemporalEmail(email) ? email : '';
    const [emailValue, setEmailValue] = useState(initialEmail);
    const trimmedEmail = emailValue.trim();

    const emailError = useMemo(() => {
        if (!trimmedEmail) {
            return 'Email is required';
        }

        if (!isEmailValid(trimmedEmail)) {
            return 'Email incorrect format';
        }

        return null;
    }, [trimmedEmail]);

    const footer = (
        <div className={styles.footer}>
            <Button
                label="Cancel"
                variant="outlined"
                fullWidth
                disabled={sending}
                onClick={onCancel}
            />
            <Button
                label="Send"
                variant="black"
                fullWidth
                isLoading={sending}
                disabled={sending || !!emailError}
                onClick={() => onSend(trimmedEmail)}
            />
        </div>
    );

    return (
        <GenericModal
            className={styles.modal}
            zIndex={30000}
            footer={footer}
            onClose={sending ? undefined : onCancel}
        >
            <div className={styles.content}>
                <h3>Send Invoice</h3>
                <p>Send this invoice to the client&apos;s email address.</p>
                <Input
                    id="single-sale-send-invoice-email"
                    label="Email"
                    type="email"
                    value={emailValue}
                    placeholder="Email Address"
                    error={emailError}
                    autoComplete="off"
                    disabled={sending}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => setEmailValue(event.target.value)}
                    onEnterPressed={() => {
                        if (!emailError && !sending) {
                            onSend(trimmedEmail);
                        }
                    }}
                />
            </div>
        </GenericModal>
    );
};

export default SendInvoiceModal;
